import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'

const browserLanguage = navigator.language
const fallbackLng = 'en-GB'
const namespaces = [
  'common',
  'assets',
  'productionRoute',
  'countriesByIsoAlpha2',
  'emissionPoints',
  'reports',
  'materials',
  'installations',
  'report',
  'organizationUsers',
  'organizationDetails',
  'importers',
  'onboarding',
  'goods',
  'settings',
  'emissionQualifyingParams',
  'integration',
  'docs',
  'installationSetup',
  'dashboard',
  'reportsV2',
  'suppliers',
  'finalizedReportDocument'
]

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    backend: {
      loadPath: '/locale/{{lng}}/{{ns}}.json'
    },
    load: 'currentOnly',
    defaultNS: 'common',
    ns: namespaces,
    fallbackLng,
    lng: browserLanguage
  })
